export default function EmergencySection() {
  const steps = [
    {
      icon: 'ri-alert-line',
      bg: 'bg-accent-400',
      title: 'Parent presses SOS button',
      desc: 'A large, easy-to-find button on the home screen triggers an alert.',
    },
    {
      icon: 'ri-notification-4-line',
      bg: 'bg-primary-500',
      title: 'Family receives instant alert',
      desc: 'All connected family members get a push notification and SMS immediately.',
    },
    {
      icon: 'ri-map-pin-line',
      bg: 'bg-secondary-500',
      title: 'Location & medical info shared',
      desc: 'Emergency contacts see the parent\'s location and critical medical details.',
    },
    {
      icon: 'ri-heart-pulse-line',
      bg: 'bg-accent-500',
      title: 'Emergency contacts respond quickly',
      desc: 'Family can coordinate the response or call for professional help.',
    },
  ];

  return (
    <section id="emergency" className="bg-primary-500 py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-accent-400/15 rounded-full px-3 py-1.5 mb-5">
            <i className="ri-alarm-warning-line text-accent-400 text-xs"></i>
            <span className="text-xs font-semibold text-accent-400 uppercase tracking-wider">Safety First</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white mb-4">
            Emergency support at the press of a button
          </h2>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
            The CareBridge emergency button allows an elderly parent to quickly alert family members and emergency contacts when help is needed.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {steps.map((step, idx) => (
            <div key={idx} className="relative">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 h-full">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${step.bg}`}>
                    <i className={`${step.icon} text-white text-lg`}></i>
                  </div>
                  {idx < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-8 -right-3 w-6 h-px bg-white/20"></div>
                  )}
                </div>
                <h3 className="text-base font-semibold text-white mb-2">{step.title}</h3>
                <p className="text-sm text-white/80 leading-relaxed">{step.desc}</p>
              </div>
              <div className="absolute -top-2 -left-2 w-6 h-6 bg-white rounded-full flex items-center justify-center text-xs font-bold text-primary-500">
                {idx + 1}
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white/5 rounded-xl p-6 border border-white/10 mb-10">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-accent-400 text-lg mt-0.5"></i>
            <div>
              <p className="text-sm text-white/90 leading-relaxed">
                <span className="font-semibold text-white">Important note:</span> CareBridge is designed to support fast family communication. It does not replace professional emergency medical services. Always call emergency services (911) in life-threatening situations.
              </p>
            </div>
          </div>
        </div>
        <div className="text-center">
          <a href="https://carebridge4elderly.base44.app" target="_blank" rel="nofollow noopener noreferrer" className="bg-accent-400 text-white font-semibold px-8 py-4 rounded-full hover:bg-accent-400/90 transition-all cursor-pointer text-sm whitespace-nowrap inline-block">
            Join the App
          </a>
        </div>
      </div>
    </section>
  );
}